import { useEffect, useState } from "react";
import Dimensions from "../Dimensions/index";
function useWindowDimensions() {
  const [dims, setDims] = useState(() => Dimensions.get("window"));
  useEffect(() => {
    function handleChange({ window }) {
      if (window != null) {
        setDims(window);
      }
    }
    Dimensions.addEventListener("change", handleChange);
    setDims(Dimensions.get("window"));
    return () => {
      Dimensions.removeEventListener("change", handleChange);
    };
  }, []);
  return dims;
}
export {
  useWindowDimensions as default
};
//# sourceMappingURL=index.js.map
